import {
  HISTORY_SEARCH_DEFAULTS,
  createHistoryRouterSearch,
  parseHistorySearch,
  type HistoryRouterSearch,
  type HistorySearchParams,
} from '@hooks/history/createHistoryRouterSearch';

export type EventHistorySearchParams = HistorySearchParams;
export type EventHistoryRouterSearch = HistoryRouterSearch;

export const EVENT_HISTORY_SEARCH_DEFAULTS: EventHistorySearchParams = HISTORY_SEARCH_DEFAULTS;

export const parseEventHistorySearch = parseHistorySearch;

export const useEventHistoryRouterSearch = createHistoryRouterSearch(
  '/orders/$orderId/events/$id/history',
);
